import React from 'react';
import s from './s.module.less';
import notQualifiedImage from '../../imgs/not-qualify.svg';
import { Button } from 'antd';

interface UserNotQualifiedProps {
    onBack: () => void;
}

export default function UserNotQualified({ onBack }: UserNotQualifiedProps) {
    return (
        <div className={s.wrap}>
            <div className={s.content}>
                <div className={s.imageContainer}>
                    <img
                        className={s.image}
                        src={notQualifiedImage}
                        alt="Not qualified"
                    />
                </div>
                <div className={s.textContent}>
                    <h1 className={s.title}>
                        We&apos;d love to have you on Klarity — here&apos;s what
                        to do next
                    </h1>
                    <div className={s.description}>
                        <p className={s.paragraph}>
                            To join Klarity Health, you need to have access to
                            an active Electronic Health Record or Revenue Cycle
                            Management system in place. These tools ensure
                            smooth patient care, proper documentation, and
                            efficient billing.
                        </p>
                        <p className={s.paragraph}>
                            Once you&apos;re set up, we&apos;d be happy to
                            welcome you to our network. 📩 Email us at{' '}
                            <a
                                className={s.emailLink}
                                href="mailto:join@Helloklarity.com"
                            >
                                join@Helloklarity.com
                            </a>{' '}
                            when you&apos;re ready, and we&apos;ll guide you
                            through the onboarding process.
                        </p>
                        <Button type="primary" onClick={onBack} className={s.backBtn}>
                            Go back
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
